import React from 'react';
import { Link } from 'react-router-dom';
import './App.css';



function Navbar() {
  return (
    <nav>
      <ul>
        <li>
          <Link to="/upload">Upload</Link>
        </li>
        <li>
          <Link to="/view-data">View Data</Link>
        </li>
      </ul>
    </nav>
  );
}

export default Navbar;
